import React from 'react';
import styled from 'styled-components'

import { Table, Icon } from '../common';
import { numberToCurrency } from 'vqp-common'
import { ProductsTableActions } from './'

const StyledTable = styled(Table)`
    & .rt-thead {
        display: none !important;
    }

    & .rt-tr {
        height: 45px;
        align-items: center;
    }
`


export const ProductsTable = ({ category, products, onDrag, onEdit, onDelete, onChangeStatus }) => {

    const columns = [{
            Cell: props => (<Icon name={"drag"} />),
            maxWidth: 40
        },
        {
            accessor: 'name',
            minWidth: 400
        },
        {
            accessor: 'price',
            Cell: props => (numberToCurrency(props.value))
        },
        {
            accessor: 'id',
            Cell: props => (
                <ProductsTableActions 
                    category={category} 
                    productId={props.value} 
                    status={props.original.status} 
                    onEdit={onEdit} 
                    onDelete={onDelete} 
                    onChangeStatus={onChangeStatus}
                />
            )
        }]
    
    return (
        <StyledTable
            className="-striped"
            data={products}
            onDragEnd={onDrag}
            columns={columns}
            draggable={true}
            noDataText={""}
        />
    )
}

